import { DEDUCTIONS } from "..";
import { apiInstance } from "../config/apiInstance";

export type PostDeductionRequest = {
  conceptCode: string;
  conceptDescription: string;
  accountingAccount: string;
  percentage: number;
  fiscalYear: number;
  effectiveStartDate: string;
  effectiveEndDate: string;
  operatingIndicator: string;
  beneficiary: string;
  beneficiaryName: string;
};

export type PostDeductionResponse = {
  id: number;
  conceptCode: string;
  conceptDescription: string;
};

export const postDeduction = async (
  data: PostDeductionRequest,
): Promise<PostDeductionResponse> => {
  const response = await apiInstance.post<PostDeductionResponse>(
    DEDUCTIONS,
    data,
  );
  return response.data;
};
